import { useEffect } from "react";
import { Nav, openTool } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { ToolSection } from "@/components/site/ToolSection";
import { MediaPair } from "@/components/site/MediaPair";
import { GeneratorSection } from "@/components/site/GeneratorSection";
import { PortalSection } from "@/components/site/PortalSection";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Studio } from "@/components/site/Studio";
import { Pricing } from "@/components/site/Pricing";
import { Faq } from "@/components/site/Faq";
import { CtaBanner } from "@/components/site/CtaBanner";
import { Footer } from "@/components/site/Footer";
import { ChatWidget } from "@/components/site/ChatWidget";
import { startLenis } from "@/lib/scroll";

const WorldChips = () => (
  <div className="mt-6 flex flex-wrap gap-2 text-xs text-slate-300">
    {["Sunset", "Night", "Desert", "Snowy Alps", "Ocean Coast", "Misty Forest", "Your own"].map((w) => (
      <span key={w} className="px-3 py-1.5 rounded-full border border-white/10 bg-white/[0.02]">{w}</span>
    ))}
  </div>
);

export default function Landing() {
  useEffect(() => {
    const stop = startLenis();
    return () => stop();
  }, []);

  return (
    <main data-testid="landing-page" className="bg-[#050505] text-white">
      <Nav />
      <Hero />
      <ToolSection
        id="tool-vehicle"
        flip
        eyebrow="Background Swap"
        title="Put your ride"
        accent="anywhere."
        text="Upload a photo or clip of your car or truck. Swap the background and keep every detail, from the paint and the lights to the wheels. Pick one of six worlds, upload your own, or type an idea."
        cta="Try Background Swap"
        onCta={() => openTool("background")}
        media={<MediaPair before="/images/truck-before.jpg" after="/images/truck-after.jpg" testId="pair-vehicle" />}
        extra={<WorldChips />}
      />
      <ToolSection
        id="tool-bike"
        eyebrow="Background Swap for bikes"
        title="Put your bike"
        accent="anywhere."
        text="Motorcycles, dirt bikes and e-bikes too. Same tool: add your photo, pick a place and keep every line of the bike."
        cta="Try it on your bike"
        onCta={() => openTool("background")}
        media={<MediaPair before="/images/ebike-before.jpg" after="/images/ebike-after.jpg" wide testId="pair-bike" />}
      />
      <GeneratorSection />
      <PortalSection />
      <HowItWorks />
      <Studio />
      <Pricing />
      <Faq />
      <CtaBanner />
      <Footer />
      <ChatWidget />
    </main>
  );
}
